import React, { Component, Fragment } from 'react';
import { Button, Col, Form, Input, Label, FormGroup } from 'reactstrap';
import * as customers from 'customers/actions/customers';
import { connect } from 'react-redux';
import { DetailContainer } from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import Loading from 'apa/components/Loading';


@connect(
    state => {
        return {
            customers: state.customers,
            auth: state.apa
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            }
        }
    }
)
class Rates extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ...props.rates,
        };
    }

    @autobind
    handleChange(event) {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    }

    @autobind
    onBlur(event) {
        event.preventDefault();
        const id = this.state.id;
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        const body = JSON.stringify(this.state);
        fetch(
            `/api/rates/${id}/`,
            { headers, method: 'PATCH', body }
        ).then(
            res => res.json()
        ).then(
            rates => this.setState({
                ...rates
            })
        )
    }

    render() {
        return (
            <Fragment>
                <FormGroup row>
                    <Col>
                        <Label>
                            Stundensatz/Grundbetreuung
										</Label>
                    </Col>
                    <Col>
                        <Input
                            onBlur={this.onBlur}
                            type='number' step='0.01'
                            value={this.state.default} name='default' onChange={this.handleChange} />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col>
                        <Label>
                            Stundensatz/Fahrzeit
										</Label>
                    </Col>
                    <Col>
                        <Input
                            onBlur={this.onBlur}
                            type='number' step='0.01'
                            value={this.state.driving} name='driving' onChange={this.handleChange} />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col>
                        <Label>
                            Stundensatz/Betriebsspezifisch
										</Label>
                    </Col>
                    <Col>
                        <Input
                            onBlur={this.onBlur}
                            type='number' step='0.01'
                            value={this.state.specific} name='specific'
                            onChange={this.handleChange} />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col>
                        <Label>
                            Stundensatz/Sonder
										</Label>
                    </Col>
                    <Col>
                        <Input
                            onBlur={this.onBlur}
                            type='number' step='0.01'
                            value={this.state.extra} name={'extra'} onChange={this.handleChange} />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col>
                        <Label>
                            Stundensatz/Projekte
										</Label>
                    </Col>
                    <Col>
                        <Input
                            onBlur={this.onBlur}
                            type='number' step='0.01'
                            value={this.state.project} name={'project'} onChange={this.handleChange} />
                    </Col>
                </FormGroup>
            </Fragment>
        )
    }
}



@connect(
    state => {
        return {
            customers: state.customers,
            auth: state.apa
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            }
        }
    }
)
export default class NumberList extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isSubmitting: false,
            isLoading: true,
            customer: null
        };
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id, customer => this.setState({ isLoading: false, customer: customer }))
    }

    @autobind
    handleChange(event) {
        const { name, value } = event.target;

        this.setState({
            customer: {
                ...this.state.customer,
                [name]: value
            }
        })
    }

    @autobind
    onSubmit(event) {
        event.preventDefault();
        const id = this.props.match.params.id;
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        const customer = this.state.customer;
        delete customer.offer_file;
        delete customer.contract_file;
        const body = JSON.stringify(customer);
        this.setState(
            {
                isSubmitting: true
            }
        );
        fetch(
            `https://apabackend.quixtest.de/api/customers/${id}/`,
            { headers, method: 'PATCH', body }
        ).then(
            res => res.json()
        ).then(
            customer => this.setState({
                isSubmitting: false,
                isLoading: false,
                customer: customer
            })
        )
    }

    render() {
        const id = this.props.match.params.id;
        const customer = this.state.customer;
        if (this.state.isLoading)
            return <Loading />;
        return (
            <DetailContainer id={id}>
                <h1>{customer.name}</h1>
                <Form>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Regelbetreuung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.target_hours} name='target_hours' onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Berechnungsinterval
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type="select"
                                value={customer.payment_interval_type}
                                name='payment_interval_type'
                                onChange={this.handleChange}
                            >
                                <option value={1}>Jährlich</option>
                                <option value={2}>Halbjährlich</option>
                                <option value={4}>Quartal</option>
                                <option value={12}>Monatlich</option>
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Beitrag
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                readOnly={true}
                                type='number' step='0.01'
                                value={customer.price} name='price' onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Beitrag Gesamt
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                readOnly={true}
                                type='number' step='0.01'
                                value={customer.price_gesamt}
                                name='price_gesamt' onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Betriebsspezifisch
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.betriebsspezifisch} name='betriebsspezifisch' onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Bezahlungsanfang
                            </Label>
                        </Col>
                        <Col>
                            <Input value={customer.paymentstartdate} type='date' name='paymentstartdate'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Nach erbrachter Leistung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.erbrachteleistung} name='erbrachteleistung'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Anfahrtpauschale
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.anfahrt} name='anfahrt' onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Kilometerpauschale
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.kilometer_pauschale} name='kilometer_pauschale'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Hotelpauschale
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.hotel_allowence} name='hotel_allowence'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Betriebsansweisung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.instructionmanual} name='instructionmanual'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Betriebsansweisung Kopie
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.instructionmanualcopy} name='instructionmanualcopy'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Schulung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.instruction} name='instruction' onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Unterweisungen
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.unterweisungen} name='unterweisungen' onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Ausbildung Brandschutzhelfer Theorie pro MA
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.ausbildungbrandschutz} name='ausbildungbrandschutz'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Jahresunterweisung - Arbeitsschutz
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.instruction_yearly_work_safety} name='instruction_yearly_work_safety'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Jahresunterweisung - Brandschutz
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.instruction_yearly_fire_safety} name='instruction_yearly_fire_safety'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Materialpauschale Unterweisungen
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.instruction_material_cost} name='instruction_material_cost'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Leiterprüfung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.ladder_exam} name='ladder_exam'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Regalprüfung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.shelf_exam} name='shelf_exam'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Brandschutzunterweisung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.fire_protection_instruction} name='fire_protection_instruction'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Label>
                                Flucht & Rettungsplan erstellt
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.escape_n_rescue_plan} name='escape_n_rescue_plan'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <Rates rates={this.state.customer.rates} />
                    <FormGroup>
                        <Button onClick={this.onSubmit} color='primary' disabled={this.state.isSubmitting}>
                            Speichern
                        </Button>
                    </FormGroup>
                </Form>
            </DetailContainer>
        )
    }
}

